import moment from 'moment-timezone';

const calcNowTime = diffBetweenServerClientTime => moment().add(diffBetweenServerClientTime, 'milliseconds');

export default calcNowTime;
